/* 自然拼读学习页面 */
/*  Author: wanfengren */
/* create: 2019/07/15*/
<template>
  <div class="mainbody">
    <div style="height:0.1px"></div>

    <!-- 自然拼读标题 -->

      <div id="headerdiv">
        <div class="headertitle">{{ lang.phonic_name }} {{Data.phonic_type}}{{Data.phonic_name}}</div>
      </div>

      <!-- 自然拼读读音介绍-->
      <div id="textDiv">
        <div class="maintext" v-if="Data.cover_video_link">
        <br>
          <img class="imgCover" id="cover_picture_link" :src="Data.cover_video_link" title="cover">
        </div>
        <div class="phonictext" v-if="Data.media_link" >
          <p>{{ lang.phonictext | multiReplace([['{phonic_name}', Data.phonic_name]])}}</p>
          <p >
            <span class="orange-bold"> {{Data.phonic_name}}     </span>
            <i class="dic-sound" @click.stop.prevent="sound(Data.media_link)"></i>
         </p>
        </div>
        <div class="phonictext" v-if="Data.word_example.length > 0">
          <p v-html="getProcessedHtml(lang['word_example_tips'], [[`{phonic_type}`, Data.phonic_type],['{phonic_name}', Data.phonic_name]])"></p>
          <div class="resource-list" id="key_word">
            <!-- <div class="word-mean flex-row-left"> -->
            <div class="flex-column-word">
             <span class='word-row' v-for="word in Data.word_example">
               <a :href="'/resource/word_v2/' + word.id + tailUrl"><span class="orange-bold">    {{word.word_name}}   </span></b> </a>
               <i class="dic-sound" @click.stop.prevent="sound(word.cej_ph_en)"></i>
             </span>
            </div>
          </div>

        </div>
      </div>

      <!-- 自然拼读对应的教学视频 -->
        <div v-if="Data.video_example.length > 0">
          <div id="headerdiv">
            <div class="headertitle">{{ lang.phonici_video }}</div>
          </div>
          <div><p style="text-align:center; font-weight: 700px" v-text="Data.video_example[0].title_cn"></p></div>
          <div class="flex-row-center">
            <iframe
             :src="Data.video_example[0].video_link"
             :width="MAXWIDTH"
             :height="MAXHEIGHT"
             frameborder="0"
             allowfullscreen=""
             :autostart = "false"
             style="z-index:1;"
             autoplay = "autoplay"></iframe>
            <!--
            <video id="video_link" class="video_iframe" controls="controls"
            preload = "preload" :src="Data.video_example[0].video_link"
              :width="MAXWIDTH"
              :height="MAXHEIGHT"
              ></video>
            -->
          </div>
        </div>

</div>
</template>

<script>
require('@/assets/css/resource.css')

import BaseVue from '@/components/BaseVue'

export default {
  name: 'PhonicTemplate',
  extends: BaseVue,
  data () {
    return {
      Data: {
        id: 23,
        phonic_name: 'ai',
        phonic_type: '',
        cover_video_link : 'http://s.kg.51talkjr.com/f42ca2e7-6ba7-4879-82c3-918ac84f2811.jpg',
        media_link: 'http://s.kg.51talkjr.com/e1a681dc-ba50-48fc-9773-21e39a1d1e33.mp3',
        video_example: [{
          id: 'FFFF466F6C214E09200CD6F37F40647C',
          title_cn: '' ,
          video_link: 'http://s.kg.51talkjr.com/b4d9d228-a7ac-4f2a-b1ec-067332e0a6ae.mp4'
        }],
        word_example: [{
          id: "39834B2193F9884074234A3BBD09365A",
          word_name: "center"
        }],
        url_params: '',
        total_duration: '',
        webviewDuration: ''
      }
    }
  },
  computed: {
    tailUrl: function() {
      return this.url_params === '' ? '' : '?' + this.url_params
    }
  },
  created: async function(){
    await this.getLang()
    document.title = this.lang.PhonicTemplateTitle
    let data_id = this.$route.params.id
    let url = this.GATEWAY_ORIGINAL + 'bigdata/unit_knowledge/query_phonic?id=' + data_id
    let that = this;
    this.queryData(url, function (data) {
      that.Data = data
      console.log('test data:')
      console.log(that.Data)
      if (that.Data.video_example){
        // 解决视频尺寸问题以及iframe在浏览器上自动播放问题
        // that.Data.video_example[0].video_link = that.resetVideoSize(that.Data.video_example[0].video_link) + "?autoPlay=false"
        that.Data.video_example[0].video_link = that.resetVideoSize(that.Data.video_example[0].video_link)
        }
      })
    },
    mounted() {
      // 在用户切换了标签页或者关闭浏览器后，暂停视频播放，并及时记录观看时间，发送到后台程序
      var video = document.getElementById("video_link");
      //视频还未加载下来，无法同步获取到，使用定时器即可解决
      let _this = this;
      setTimeout(()=> {
        // 计算视频总时长
        this.total_duration = video.duration
        console.log("total duration:" + this.total_duration)
        // 计算当前时长
        if (typeof video.addEventListener === "undefined") {
          console.error("浏览器不支持addEventListener,请升级");
        }
        else {
          video.addEventListener("visibilitychange", () => {
            if (video.visibilityState == "hidden") {
              _this.sendCurVideoTime(localStorage.getItem("webviewDuration"))
              console.log('webviewduration:'+localStorage.webviewDuration)
            }
          });
          window.addEventListener("beforeunload", () => {
             this.sendCurVideoTime(localStorage.getItem("webviewDuration"));
             console.log('windown webviewduration:'+localStorage.webviewDuration)
          });
        }
      },3000)


    },
  methods: {
    getProcessedHtml(value, params) {
      let processedString = this.$options.filters.multiReplace(value, params);
      return processedString;
    },
    sound: function(url){
      var audio= new Audio(url);
      audio.play() //autoplay自动播放 loop循环播放  pause暂停
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/resource/Phonic.vue